import React from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

interface SortArrowsProps {
  selectedSort: string;
  sort: string;
  isDesc?: boolean;
  setDesc: Function;
  setSortBy: Function;
}

export const SortArrows: React.FC<SortArrowsProps> = ({ selectedSort, sort, isDesc, setDesc, setSortBy }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", cursor: "context-menu" }}>
      <ArrowDropUpIcon
        sx={{
          fontSize: "20px",
          color: sort == selectedSort && !isDesc ? "rgba(10, 49, 66, 0.7)" : "#bac7ce"
        }}
        style={{
          marginBottom: -10
        }}
        onClick={() => {
          setDesc(false);
          setSortBy(sort);
        }}
      />
      <ArrowDropDownIcon
        sx={{
          fontSize: "20px",
          color: sort == selectedSort && isDesc ? "rgba(10, 49, 66, 0.7)" : "#bac7ce"
        }}
        onClick={() => {
          setDesc(true);
          setSortBy(sort);
        }}
      />
    </div>
  );
};
